import { API_POST_JUDGMENT, API_APPROVE_ALL } from "../../constants/api";
import API from "..";

export const postJudgmentAPI = async (data) => {
  try {
    const headers = { "Content-Type": "application/json" };
    const response = await API.post(API_POST_JUDGMENT, JSON.stringify(data), {
      headers: headers,
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const approveAllAPI = async (perform_approve) => {
  try {
    const headers = { "Content-Type": "application/json" };
    const response = await API.post(
      API_APPROVE_ALL,
      {
        perform_approve: perform_approve,
      },
      {
        headers: headers,
      }
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};
